import React from 'react'
import * as S from './styled'
import Img from 'gatsby-image'
import { isMedium } from '../../../../../utils/src/mediaQuery';

export const CardWithImg = ({ img, title, description, alt = '' }) => {

  const isMed = isMedium();

  return (
    <S.ContainerCardWithImg>
      <S.ContentImg>
        <Img
        style={{ width: isMed ? "100%" : '200px', height: "100%" }}
        imgStyle={{ objectFit: "cover" }}
        fluid={img} alt={alt} />
      </S.ContentImg>
      <S.ContentText>
        <S.TextTitle>{title}</S.TextTitle>
        <S.TextDescription>{description}</S.TextDescription>
      </S.ContentText>
    </S.ContainerCardWithImg>
  )
}
